import { render } from "./PhotoGallery.vue?vue&type=template&id=a6bb866e&scoped=true"
import script from "./PhotoGallery.vue?vue&type=script&lang=js"
export * from "./PhotoGallery.vue?vue&type=script&lang=js"

import "./PhotoGallery.vue?vue&type=style&index=0&id=a6bb866e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6bb866e"]])

export default __exports__